import React, { Component, createRef } from 'react';
import RenderAnimationScene from './RenderAnimationScene';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './RenderAnimation.scss';
import {
    ZoomDataAnim,
    setZoomAnimAction,
} from '../../../../Redux/Actions/Animator/zoom.anim.action';
import { connect } from 'react-redux';
import { RootState } from '../../../../Redux/Store/store';
import { isEmpty } from 'ramda';
import { GLOBAL_EVENT_ANIM } from '../../Observer';
import { ActionAnimationList } from '../../../../Redux/Reducers/Animator/animation.list.reducer';

interface propsData {
    zoom: number;
    setZoomAnimAction: (value: ZoomDataAnim) => void;
    atlasAnim: any;
    backgroundColor: string;
    animationList: ActionAnimationList;
}

class RenderAnimation extends Component<propsData> {
    canvas_container: React.RefObject<HTMLDivElement> = createRef<HTMLDivElement>();
    canvas: React.RefObject<HTMLDivElement> = createRef<HTMLDivElement>();
    game_config: Phaser.Types.Core.GameConfig = {
        width: 200,
        height: 200,
        parent: 'canvas-animation',
        type: Phaser.WEBGL,
        dom: {
            createContainer: true,
        },
        banner: {
            hidePhaser: true,
        },
        audio: {
            noAudio: true,
        },
        render: {
            transparent: true,
            pixelArt: true,
        },
        scene: [RenderAnimationScene],
    };
    game!: Phaser.Game;

    zoom_step = 20;

    scrollBarAnimRef: any = createRef<any>();

    constructor(props: any) {
        super(props);
        this.handleWheel = this.handleWheel.bind(this);
    }

    componentDidMount() {
        this.game = new Phaser.Game(this.game_config);
        this.canvas_container.current?.addEventListener('wheel', this.handleWheel, {
            passive: false,
        });
    }

    handleWheel(event: any): void {
        if (event.ctrlKey) {
            const zoom = this.props.zoom;
            let value = zoom;
            if (Math.abs(event.deltaY) >= 0) {
                if (zoom >= 20 && zoom <= 500) {
                    value = Number(
                        (
                            zoom -
                            (this.zoom_step * event.deltaY) / Math.abs(event.deltaY)
                        ).toPrecision(2)
                    );
                    value = value < 20 ? (value = 20) : value > 500 ? (value = 500) : value;
                }
            }
            this.comprobateSize();
            this.props.setZoomAnimAction({ value });
            event.preventDefault();
            event.stopPropagation();
        }
    }

    componentDidUpdate(state: propsData) {
        if (state.backgroundColor !== this.props.backgroundColor) {
            this.game.scene?.getScene('RenderAnimationScene')?.cameras?.main?.setBackgroundColor(this.props.backgroundColor)
        }

        if (state.zoom !== this.props.zoom) {
            const new_zoom: number = this.props.zoom / 100;
            this.game.registry.events.emit(GLOBAL_EVENT_ANIM.RENDER.SET_ZOOM, new_zoom);
        }

        if (
            state.atlasAnim.image !== this.props.atlasAnim.image ||
            state.atlasAnim.json !== this.props.atlasAnim.json
        ) {
            if (!isEmpty(this.props.atlasAnim.image) && !isEmpty(this.props.atlasAnim.json)) {
                this.game.registry.events.emit(
                    GLOBAL_EVENT_ANIM.RENDER.IMPORT_ATLAS,
                    this.props.atlasAnim
                );
            }
        }

        // Se cambia de animación y si no existe se crea un contenedor
        if (state.animationList.actual_animation !== this.props.animationList.actual_animation) {
            this.game.registry.events.emit(
                GLOBAL_EVENT_ANIM.RENDER.CHANGE_OR_CREATE_ANIMATION_CONTAINER,
                this.props.animationList
            );
        }

        // Agregamos los frames
        if (
            state.animationList.animations !== this.props.animationList.animations &&
            this.props.animationList.actual_animation !== '0'
        ) {
            this.game.registry.events.emit(
                GLOBAL_EVENT_ANIM.RENDER.ADD_OR_REMOVE_FRAME_TO_ANIMATION_CONTAINER,
                this.props.animationList
            );
        }

        this.scrollBarAnimRef?.updateScroll();

        this.game.scene
            .getScene('RenderAnimationScene')
            .load.once(Phaser.Loader.Events.COMPLETE, () => {
                this.comprobateSize();
            });
    }

    comprobateSize() {
        const container_panel = document.querySelector('#center-anim-panel--up') as HTMLDivElement;
        const canvas_width = this.canvas.current!.clientWidth || 0;
        const canvas_height = this.canvas.current!.clientHeight || 0;

        if (canvas_width > container_panel?.clientWidth) {
            this.canvas.current?.classList.add('pl-2');
            this.canvas.current?.querySelector('canvas')!.classList.add('mr-2');
        } else {
            this.canvas.current?.classList.remove('pl-2');
            this.canvas.current?.querySelector('canvas')!.classList.remove('mr-2');
        }
        if (canvas_height > container_panel?.clientHeight) {
            this.canvas.current!.style.paddingTop =
                (canvas_height - container_panel?.clientHeight) / 2 + 20 + 'px';
            this.canvas.current!.style.paddingBottom = 10 + 'px';
            // this.canvas.current?.querySelector('canvas')?.classList.add('mt-4');
        } else {
            // this.canvas.current?.classList.remove('padding-100');
            this.canvas.current!.style.paddingTop = '0px';
            this.canvas.current!.style.paddingBottom = '0px';
        }
    }

    render() {
        const frames_list_state = this.props.animationList;
        const frames_list = frames_list_state.animations.find(
            (animation) => animation.id === frames_list_state.actual_animation
        );

        return (
            <div
                ref={this.canvas_container}
                className={`render-animation-container d-flex justify-content-center align-items-center debug-white}`}
            >
                <PerfectScrollbar
                    className="scrollContainerAnimator"
                    ref={(ref) => (this.scrollBarAnimRef = ref)}
                >
                    {frames_list === undefined || frames_list.frames.length < 1 ? (
                        <div className="logo noselect">
                            <img
                                src={require('../../../../Vendor/logo.gif')}
                                alt="logo"
                                draggable={false}
                                style={{
                                    display:
                                        frames_list === undefined || frames_list.frames.length < 1
                                            ? 'block'
                                            : 'none',
                                }}
                            />
                        </div>
                    ) : null}
                    <div
                        id="canvas-animation"
                        ref={this.canvas}
                        style={{
                            display:
                                frames_list === undefined || frames_list.frames.length < 1
                                    ? 'none'
                                    : 'block',
                        }}
                    ></div>
                </PerfectScrollbar>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        zoom: state.zoomAnim.value,
        backgroundColor: state.backgroundAnim.value,
        atlasAnim: state.atlasAnim,
        animationList: state.AnimationList,
    };
};

const mapDispatchToProps = {
    setZoomAnimAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(RenderAnimation);
